import { render, staticRenderFns } from "./TesTableCell.vue?vue&type=template&id=4380494a&"
import script from "./TesTableCell.vue?vue&type=script&lang=ts&"
export * from "./TesTableCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports